import { useAppDispatch } from "hooks/hooks";
import {
  getAllIncidentsForEmployee,
  selectState,
  setNewIncidentPopover,
  setSearchPopover,
} from "../incident.slice";
import SearchIncidentPopover from "./SearchIncidentPopover";
import ToolboxButton from "../../../components/Buttons/ToolboxButton";
import { ToolboxButtonIcon } from "Dashboard/components/Buttons/ToolboxButton";
import { useNavigate } from "react-router-dom";
import Popover from "components/Popover/Popover";
import NewIncidentPopover from "./NewIncidentPopover";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { IIncidentUpdate } from "../domain/IIncidentUpdate";
import { useState } from "react";
import { IOption } from "Dashboard/domain/IOption";
import { IIncidentSearch } from "../domain/IIncidentSearch";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { hasWriteAccessTo } from "utils/authUtil";
import { INCIDENT_MODULE_NAME } from "../domain/IncidentModule";
import { areQueryParamsEmpty } from "utils/queryParamsUtil";

export const Toolbox = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { newIncidentPopover, searchPopover }
    = useSelector(selectState);
  const { user } = useSelector(selectStateAuth);

  const {
    handleSubmit,
    register,
    control,
    getValues,
    formState: { errors },
    reset,
  } = useForm<IIncidentUpdate>();
  const [incidentTypeValue, setIncidentTypeValue]
    = useState<IOption | undefined>(undefined);

  const {
    handleSubmit: handleSubmitSearch,
    reset: resetSearch,
    control: controlSearch,
    getValues: getValuesSearch,
    setFocus: setFocusSearch,
    setValue: setValueSearch
  } = useForm<IIncidentSearch>();

  const isSearchFormEmpty = areQueryParamsEmpty(getValuesSearch());

  return (
    <>
      <nav>
        <div>
          <ToolboxButton
            icon={ToolboxButtonIcon.Back}
            tooltip="Glavni meni"
            toolbox={true}
            onClick={() => navigate('/dashboard')}
          />
        </div>
        <div>
          <ToolboxButton
            icon={ToolboxButtonIcon.Add}
            tooltip="Novi"
            toolbox={true}
            onClick={hasWriteAccessTo(user, INCIDENT_MODULE_NAME)
              ? () => dispatch(setNewIncidentPopover({ isOpen: true }))
              : undefined}
          />
          <ToolboxButton
            icon={ToolboxButtonIcon.Search}
            tooltip="Traži"
            toolbox={true}
            onClick={() => dispatch(setSearchPopover({ isOpen: true }))}
          />
          {!isSearchFormEmpty
            && (<ToolboxButton
              icon={ToolboxButtonIcon.CancelSearch}
              tiny={true}
              tooltip="Pokaži sve"
              onClick={() => {
                dispatch(getAllIncidentsForEmployee());
                resetSearch();
              }}
            />)}
          <ToolboxButton
            icon={ToolboxButtonIcon.Print}
            toolbox={true} />
        </div>
      </nav>
      <Popover
        isOpen={newIncidentPopover.isOpen}
        onClose={() => dispatch(setNewIncidentPopover({ isOpen: false }))}
        title="Dodaj incident"
        direction="right"
        arrowStyle={{ top: "42px" }}
        position={{ top: 10, left: 185 }}
      >
        <NewIncidentPopover
          handleSubmit={handleSubmit}
          control={control}
          getValues={getValues}
          register={register}
          errors={errors}
          reset={reset}
          incidentTypeValue={incidentTypeValue}
          setIncidentTypeValue={setIncidentTypeValue}
        />
      </Popover>
      <Popover
        isOpen={searchPopover.isOpen}
        onClose={() => dispatch(setSearchPopover({ isOpen: false }))}
        title="Pretraga"
        direction="right"
        arrowStyle={{ top: "42px" }}
        position={{ top: 10, left: 245 }}
      >
        <SearchIncidentPopover
          handleSubmit={handleSubmitSearch}
          control={controlSearch}
          setValue={setValueSearch}
          getValues={getValuesSearch}
          setFocus={setFocusSearch}
        />
      </Popover>
    </>
  );
};
